import { NextRouter } from "next/router";
import { isServerSide } from "src/utils/common-util";

export const getQueryString = (router: NextRouter) => {
    const url = router.asPath;
    if (url?.includes("?")) {
        return url.split("?")[1];
    }
    return null;
};

export const getPathnameFromRouter = (router: NextRouter) => {
    const url = router.asPath;
    return url.split("?")[0].split("#")[0];
};

export const isValidAbsoluteUrl = (url: string) => {
    try {
        const urlObj = new URL(url);
        return urlObj.protocol === "https:" || urlObj.protocol === "http:";
    } catch {
        return false;
    }
};

export const getDecodedUrlHash = () => {
    if (isServerSide()) {
        return "";
    }

    const hash = window.location.hash.slice(1);

    try {
        return decodeURIComponent(hash);
    } catch {
        return hash;
    }
};
